export const getDeviceInfo = () => {
    return new Promise((resolve, reject) => {

        let deviceId = localStorage.getItem("device_id");
        if (!deviceId) {
            deviceId = crypto.randomUUID();
            localStorage.setItem("device_id", deviceId);
        }

        if (!navigator.geolocation) {
            return reject("Geolocation not supported");
        }

        navigator.permissions.query({ name: "geolocation" }).then((result) => {
            console.log("Permission state:", result.state);
        });

        navigator.geolocation.getCurrentPosition(
            async (position) => {
                const latitude = position.coords.latitude;
                const longitude = position.coords.longitude;
                
                const ipResponse = await fetch("https://api.ipify.org?format=json");
                const ipData = await ipResponse.json();

                resolve({
                    deviceId,
                    latitude,
                    longitude,
                    ipAddress: ipData.ip,
                });
            },
            (error) => {
                console.error("Geolocation Error:", error);
                reject(error);
            },
            {
                enableHighAccuracy: false,
                timeout: 10000,
                maximumAge: 0,
            }
        );
    });
};
